import { ADD_ENTITIES, CLEAR_ENTITIES, SET_ENT_FETCHING } from "./types";

export const setEntityFetching = () => {
  return {
    type: SET_ENT_FETCHING,
  };
};

//Set entities
export const addEntities = (entities) => {
  return {
    type: ADD_ENTITIES,
    payload: entities,
  };
};

//clear entities
export const clearEntities = () => {
  return {
    type: CLEAR_ENTITIES,
  };
};
